import React from 'react';
import { rootUseStyles } from '../../../taskpane/fluent-style';
import ReportPhishingButton from '../../common/report-phishing-button';
import ThreatDescriptions from './ThreatDescriptions';
import ThreatList from './ThreatList';
import { Button, makeStyles } from '@fluentui/react-components';
import { useTabStore } from '../../../providers/TabProvider';

const useStyles = makeStyles({
    section2: {
        padding: "0px 15px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
    },
});

import { IndicatorStatusType, ScanResultByGroupIdType } from '../../../types';

interface DeepScanResultContentProps {
    showActions?: boolean;
    threatItems?: ScanResultByGroupIdType;
    indicatorStatus?: IndicatorStatusType;
}

export default function DeepScanResultContent({
    showActions = true,
    threatItems,
    indicatorStatus
}: DeepScanResultContentProps) {
    const styles = useStyles();
    const setActiveTab = useTabStore((s) => s.setActiveTab);

    return (
        <>
            <section
                style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                }}
                className={`${rootUseStyles().scrollArea} ${rootUseStyles().scrollbar}`}
            >
                <ThreatDescriptions
                    threatItems={threatItems}
                    indicatorStatus={indicatorStatus}
                    isScanning={threatItems ? false : undefined}
                />
                <ThreatList
                    threatResults={threatItems}
                />
            </section>
            {showActions && (
                <section className={`${styles.section2}`}>
                    <ReportPhishingButton currentTab='deep-scan-result' />
                    <Button
                        className={rootUseStyles().buttonInfoOutline}
                        onClick={() => setActiveTab("overview")}
                    >
                        Overview
                    </Button>
                </section>
            )}
        </>
    );
}
